<template>
    <!-- 系统登录页 -->
    <div :class="getBackground.backgroundImage" :style="{ backgroundColor: backgroundColor }">
        <!--    <img-->
        <!--      src="../../assets/img/title.png"-->
        <!--      alt=""-->
        <!--      class="login-wrap-title"-->
        <!--    >-->
        <div class="ms-login">
            <div class="ms-title">{{ proName }}v3代驾管理后台</div>
            <div class="ms-login-input">
                <el-form :model="formData" label-width="0px" class="ms-content">
                    <el-row type="flex" style="margin: 10px 0">
                        <el-input
                            type="text"
                            v-model="formData.user_name"
                            :placeholder="formRules.user_name.placeholder"
                            :value="formData.user_name"
                            class="login-input"
                            prefix-icon="el-icon-user"
                            @keyup.enter.native="submitForm"
                        >
                        </el-input>
                    </el-row>

                    <el-row type="flex" style="margin: 10px 0">
                        <el-input
                            type="password"
                            v-model="formData.password"
                            :placeholder="formRules.password.placeholder"
                            :value="formData.password"
                            class="login-input"
                            prefix-icon="el-icon-goods"
                            @keyup.enter.native="submitForm"
                        >
                        </el-input>
                    </el-row>

                    <!-- <el-row type="flex" style="margin: 10px 0">
                        <el-input
                            type="password"
                            v-model="formData.google_code"
                            :placeholder="formRules.google_code.placeholder"
                            :value="formData.google_code"
                            class="login-input"
                            prefix-icon="el-icon-paperclip"
                            maxlength="6"
                            @keyup.enter.native="submitForm"
                        >
                        </el-input>
                    </el-row> -->

                    <!-- <el-row type="flex" style="margin: 10px 0">
                    <div class="city-select">
                        <el-select
                            v-model="city_tag"
                            filterable
                            placeholder="请选择城市"
                            style="width: 180px"
                            @visible-change="cityVisible"
                            @change="cityChange"
                        >
                            <el-option-group
                                v-for="group in city_data"
                                :key="group.label"
                                v-if="group[0].alias != '主库'"
                                :label="group[0].alias"
                            >
                                <el-option v-for="item in group" :key="item.city_tag" :label="item.include" :value="item.city_tag">
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </div>
                </el-row> -->

                    <div style="margin: 10px 0; display: flex">
                        <el-input
                            type="text"
                            id="code"
                            v-model="code"
                            placeholder="请输入验证码"
                            :value="formData.google_code"
                            style="width: 180px"
                            class="login-input"
                            prefix-icon="el-icon-magic-stick"
                            @keyup.enter.native="submitForm"
                        >
                        </el-input>
                        <!--验证码组件-->
                        <s-identify :identifyCode="identifyCode" @re="re"></s-identify>
                    </div>

                    <div :class="getBackground.btnColo" class="login-btn">
                        <!-- <el-button type="primary" @click="submitForm">登录 </el-button> -->
                        <el-button type="primary" :disabled="loginLoading" @click="submitForm">{{
                            loginLoading == true ? '登录中...' : '登录'
                        }}</el-button>
                    </div>
                </el-form>
            </div>
        </div>

        <!-- 谷歌验证模态框 -->
        <el-dialog
            title="使用谷歌验证器扫描绑定"
            :visible.sync="param.gooleDegModel"
            width="300px"
            :before-close="handleClose"
            center
            style="text-align: center"
        >
            <img :src="param.pictureCode" alt="谷歌验证二维码" id="pictureCode" />
            <div class="text">
                <p>点击下方文字下载谷歌验证器</p>
                <div style="display: flex; justify-content: center; margin-top: 20px">
                    <el-button type="text" @click="param.Android_download = true">安卓版 </el-button>
                    <span style="display: inline-block; width: 1px; height: 20px; background-color: #ccc; margin: 5px 10px 0"></span>
                    <el-button type="text" @click="param.ios_download = true">ios版 </el-button>
                </div>
            </div>
            <!-- 谷歌验证器秘钥 -->
            <el-input type="text" v-model="param.googleKey" placeholder="谷歌验证器秘钥" @keyup.enter.native="googleKey()"> </el-input>
            <el-button @click="googleKey()" type="primary" class="btn">进行验证 </el-button>
        </el-dialog>

        <el-dialog
            title="扫描二维码下载安卓版谷歌验证器"
            :visible.sync="param.Android_download"
            width="800px"
            center
            style="text-align: center"
            class="android-download"
        >
            <p style="text-align: center">谷歌秘钥：{{ google_secret }}</p>
            <img src="../../assets/Android.png" alt="" style="display: block; margin: 0 auto" />
        </el-dialog>

        <el-dialog
            title="扫描二维码下载ios版谷歌验证器"
            :visible.sync="param.ios_download"
            width="800px"
            center
            style="text-align: center"
            class="ios-download"
        >
            <p style="text-align: center">谷歌秘钥：{{ google_secret }}</p>
            <img src="../../assets/ios.png" alt="" style="display: block; margin: 0 auto" />
        </el-dialog>
    </div>
</template>

<script>
var _this;
import axios from 'axios'; // AJAX封装类
import { config } from '../../utils/config'; //配置
import SIdentify from '../common/sidentify';
import bus from '../common/bus';

export default {
    components: {
        SIdentify
    },
    computed: {
        // 根据config配置文件的项目名称动态改变登录页面背景图片的类名，以更改不同项目的背景图片
        getBackground() {
            switch (config.proType) {
                case '九州':
                    return { backgroundImage: 'login-wrap', btnColo: 'login-btn' };
                case '马上':
                    return { backgroundImage: 'login-wrap-ma', btnColo: 'login-btn' };
                case '羚师傅':
                    return { backgroundImage: 'login-wrap-ling', btnColo: 'login-btn-ling' };
                case '白师傅':
                    return { backgroundImage: 'login-wrap-bai', btnColo: 'login-btn-bai' };
                    '';
                case '青鸟':
                    return { backgroundImage: 'login-wrap-bird', btnColo: 'login-btn-bird' };
            }
        }
    },
    created() {
        _this = this;


        localStorage.removeItem('access_token');
  
        sessionStorage.removeItem('navBar');

        _this.refreshCode();

        //获取当前城市信息
        // AMap.plugin('AMap.CitySearch', function () {
        //     var citySearch = new AMap.CitySearch();
        //     citySearch.getLocalCity(function (status, result) {
        //         console.log(result);
        //         if (status === 'complete' && result.info === 'OK') {
        //             // 查询成功，result即为当前所在城市信息

        //             axios.defaults.baseURL = config.axios_normalURL; //请求normal url

        //             _this
        //                 .$post(
        //                     '/city/getCityTag',
        //                     {
        //                         area_code: result.adcode
        //                     },
        //                     {},
        //                     'normal'
        //                 )
        //                 .then((res) => {
        //                     _this.city_tag = res.data.name;

        //                     if (res.data.city_tag != undefined && res.data.city_tag != '' && res.data.city_tag != null) {
        //                         // 设置city_tag
        //                         localStorage.setItem('city_tag', res.data.city_tag);
        //                     }

        //                     // _this.city_data = res.data;
        //                     axios.defaults.baseURL = config.axios_baseURL; //请求normal url
        //                 });

        //             axios.defaults.baseURL = config.axios_baseURL; //请求base url
        //         }
        //     });
        // });
    },
    mounted() {
        this.identifyCode = '';
        this.makeCode(this.identifyCodes, 4);
    },

    data: function () {
        return {
            backgroundColor: config.proColor, // 登录页背景颜色
            proName: config.proType, // 不同项目展示不同项目名称 比如九州代驾，羚师傅，马上代驾，白师傅代驾等
            //城市数据
            city_data: [],
            city_tag: '',
            loginLoading: false,

            google_secret: '',
            formData: {
                user_name: '',
                password: '',
                google_code: '',
                user_name: '',
                password: '',
                // google_code: ''
            },
            identifyCodes: '1234567890',
            identifyCode: '',
            code: '', //text框输入的验证码
            formRules: {
                user_name: {
                    placeholder: '用户名',
                    rules: {
                        required: true,
                        message: '用户名必须为8-20位',
                        regulation: 'between_str',
                        rulesData: [8, 20]
                    }
                },
                password: {
                    placeholder: '密码',
                    rules: {
                        required: true,
                        message: '密码必须为8-20位',
                        regulation: 'between_str',
                        rulesData: [8, 20]
                    }
                },
                google_code: {
                    placeholder: '谷歌验证码',
                    rules: {
                        required: false,
                        message: '谷歌验证码为6位数字',
                        regulation: 'eq_num',
                        rulesData: 6
                    }
                }
            },

            param: {
                gooleDegModel: false,
                pictureCode: '',
                googleKey: '',
                Android_download: false,
                ios_download: false
            }
        };
    },
    methods: {
        //获取登录页面城市数据
        // cityVisible() {
        //     if (_this.city_data.length == 0) {
        //         axios.defaults.baseURL = config.axios_normalURL; //请求normalURL

        //         _this
        //             .$post('/city/getCityLists')
        //             .then((res) => {
        //                 _this.city_data = res.data;

        //                 axios.defaults.baseURL = config.axios_baseURL; //请求base url
        //             })
        //             .catch((err) => {});
        //         axios.defaults.baseURL = config.axios_baseURL; //请求base url
        //     }
        // },
        // 城市选中事件
        cityChange(val) {
            // 设置city_tag
            localStorage.setItem('city_tag', val);
        },

        //验证码
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },

        refreshCode() {
            this.identifyCode = '';
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
            }
        },
        re(msg) {
            this.identifyCode = msg;
        },

        // 登录按钮方法
        submitForm() {
            _this.loginLoading = true;

            localStorage.setItem(config.localStorage_token_name, '');
            // 判断验证码
            if (this.code == '') {
                _this.$message.error('请输入验证码');
                _this.loginLoading = false;

                return;
            }
            if (this.identifyCode !== this.code) {
                this.code = '';
                this.refreshCode();
                _this.$message.error('请驶入正确的验证码');
                _this.loginLoading = false;

                return;
            }

            // if (this.city_tag == '') {
            //     _this.$message.error('请选择城市');
            //     return;
            // }
            bus.$on('btnStatus', (val) => {
                _this.loginLoading = val;
                // 接收http.js if (rules !== {}) {}里面的bus.$emit('btnStatus', false)，验证不通过，取消按钮loading
            });
            _this
                .$post('/welcome/loginsubmit', _this.formData, _this.formRules)
                .then((res) => {
                    _this.loginLoading = false;

                    if (res.code === 200) {
                        //弹出显示成功
                        this.$message.success(res.msg);
                        //设置缓存
                        localStorage.setItem(config.localStorage_token_name, res.data.access_token);
                        localStorage.setItem('city_tag', res.data.city_tag);

                        bus.$emit('logIn');

                        // 获取登录信息
                        _this
                            .$post('/mine/tokenDetails')
                            .then((res) => {
                                // 缓存登录信息
                                localStorage.setItem('login', JSON.stringify(res.data));
                                // console.log(res.data.menu, '==========');
                                // 跳转路由至首页并传参 ----------->获取服务费是否预警
                                _this.$router.push({
                                    path: '/' + res.data.menu
                                });
                                bus.$emit('getMessage'); // 登录成功后触发App.vue的方法，轮询获取服务费是否预警
                            })
                            .catch((err) => {});
                    } else if (res.data.code === 888) {
                        //谷歌验证模态框显示
                        _this.param.gooleDegModel = true;

                        _this.google_secret = res.data.data.google_secret;

                        _this.param.pictureCode = res.data.data.google_qrcode_url;
                    }
                })
                .catch((err) => {
                    this.$message.error(err.msg);
                });
        },
        // 对话框关闭
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },

        // 谷歌秘钥验证
        googleKey() {
            _this
                .$post('/welcome/googleStatus', {
                    user_name: _this.formData.user_name,
                    google_code: _this.param.googleKey
                })
                .then((res) => {
                    // 弹出提示框
                    if (res.code === 200) {
                        //弹出提示框
                        _this.$message(res.msg);
                        // 关闭对话框
                        _this.param.gooleDegModel = false;
                    }
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
/* 九州代驾背景图 和马上代驾背景图是一个*/
.login-wrap {
    position: relative;
    background-image: url('../../assets/img/new.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: 100vh;
}
/* 马上代驾背景图 */
.login-wrap-ma {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url('../../assets/img/new.png');
    background-size: 100% 100%;
}

/* 羚师傅 白师傅代驾背景图 是一个*/
.login-wrap-ling {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url('../../assets/img/ling.png');
    background-size: 100% 100%;
}
/* 羚师傅 白师傅代驾背景图 是一个*/
.login-wrap-bai {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url('../../assets/img/ling.png');
    background-size: 100% 100%;
}
/* 青鸟 跟九州用一个*/
.login-wrap-bird {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url('../../assets/img/new.png');
    background-size: 100% 100%;
}

.login-wrap-title {
    position: absolute;
    bottom: 15%;
    right: 150px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin: 20px 0;
}
.ms-login {
    position: absolute;
    top: 50%;
    left: 75%;
    transform: translate(-50%, -50%);
}
.ms-title {
    width: 100%;
    text-align: center;
    height: 120px;
    line-height: 120px;
    margin-bottom: 20px;
    font-size: 60px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
}
@media screen and (min-width: 1901px) {
    .ms-login-input {
        width: 450px;
    }
    .ms-title {
        font-size: 50px;
    }
}

@media screen and (max-width: 1900px) {
    .ms-title {
        font-size: 50px;
    }
    .ms-login-input {
        width: 400px;
    }
}

@media screen and (max-width: 1800px) {
    .ms-title {
        font-size: 40px;
    }
    .ms-login-input {
        width: 380px;
    }
}
@media screen and (max-width: 1600px) {
    .ms-title {
        font-size: 40px;
    }
    .ms-login-input {
        width: 350px;
    }
}
@media screen and (max-width: 1500px) {
    .ms-login-input {
        width: 350px;
    }
    .ms-title {
        width: 350px;
        font-size: 30px;
    }
    .ms-login {
        width: 350px;
    }
}

.ms-login-input {
    border-radius: 20px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    padding: 40px !important;
    box-sizing: border-box;
    overflow: hidden;
}

.ms-content {
    padding: 20px;
}

.login-btn {
    text-align: center;
    margin-top: 30px;
}

.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}

#pictureCode {
    display: block;
    margin: 0 auto;
    width: 200px;
    height: 200px;
}

.text {
    width: 100%;
    display: block;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
}

.text p {
    width: 100%;
    text-align: center;
}

.btn {
    display: block;
    margin: 20px auto;
}

/* 九州代驾登录按钮样式 */
.login-btn .el-button.el-button--primary.el-button--small {
    background-color: #05c0ab;
    border: 0;
}

/* 陕西羚师傅代驾登录按钮样式 */
.login-btn-ling .el-button.el-button--primary.el-button--small {
    background-color: #0ec879;
    border: 0;
}
/* 白师傅代驾登录按钮样式 */
.login-btn-bai .el-button.el-button--primary.el-button--small {
    background-color: #0ec879;
    border: 0;
}
/* 马上代驾登录按钮样式 */
.login-btn-ma .el-button.el-button--primary.el-button--small {
    background-color: #01c0ab;
    border: 0;
}
/* 青鸟代驾登录按钮样式 */
.login-btn-bird .el-button.el-button--primary.el-button--small {
    /* 青鸟移动端颜色如下，跟九州差不多，就用九州颜色了 */
    /* background-color: #34C5B6; */
    background-color: #05c0ab;

    border: 0;
}

.login-span {
    font-size: 12px;
    color: #ccc;
    display: inline-block;
    min-width: 70px;
    height: 32px;
    line-height: 32px;
    text-align: right;
    padding-right: 5px;
    box-sizing: border-box;
}
</style>
